module.exports = __webpack_public_path__ + "static/media/logo-white.85535295.svg";